// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__3BZK7","loader":"style_loader__JxFNe"};